import { has } from "../../../../../utils/menu-context";
import store from "../../../../../store";
import lodash from "lodash";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refParent",
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                let enabled = false;
                let group = lodash.cloneDeep(modelRef.group);
                let renderLabel = ({ item }) => (<span>{item.key} - {item.value}</span>);
                if (modelRef.group === "HAZ_ANIMAL_SPECIES_TEST") {
                    group = "HAZ_ANIMAL_TEST";
                    renderLabel = ({ item }) => (<span>[{item.group}] {item.key} - {item.value}</span>);
                } else if (modelRef.group === "HAZ_PRODUCT_USE") {
                    group = "HAZ_PRODUCT_USE_DISCUSS";
                    renderLabel = ({ item }) => (<span>[{item.group}] {item.key} - {item.value}</span>);
                } else if (modelRef.group === "HAZ_SUB_AQUATIC_TYPE") {
                    group = "HAZ_AQUATIC_TYPE";
                    renderLabel = ({ item }) => (<span>[{item.group}] {item.key} - {item.value}</span>);
                }
                enabled = !viewOnly || enabled;
                return {
                    list: ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group, value: searchQuery }),
                    renderLabel,
                    disabled: !enabled,
                };
            }
        },
    ];
};
